import React, { Component, lazy } from 'react';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import LazyBoundary from '@com/LazyBoundary';
import MeetingRoomReport from './utils/report';
import { MEETING_SCENE_SOURCE, ROLE, DOC_TYPE } from '@src/page/toc/common/meeting-room-manager/message_const';
import stylesMobile from './style-mobile.less';
import stylesPC from './style-pc.less';
import MeetingRoom from './components/meeting-room';
import { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
const SlidePlayer = lazy(() => import(/* webpackChunkName: "lazySlidePlayer" */ '@src/framework/meeting-room-slidePlayer/SlidePlayerv2'));

const styles = browser.isMobile ? stylesMobile : stylesPC;

interface IMeetingRoomEntryProps {
    currentPage: number;
    roomId: string;
    handleEndPlay?: (pageIndex) => any;
    liveManager: ILiveManager;
}

// 从 pc 编辑态进入远程演示
export default class MeetingRoomEntry extends Component<IMeetingRoomEntryProps, {}> {
    private meetingRoomReport = MeetingRoomReport.getInstance();
    private sceneSource: MEETING_SCENE_SOURCE;
    private docId: string;
    private docType: DOC_TYPE;
    private role: ROLE;
    public constructor(props: IMeetingRoomEntryProps) {
        super(props);
        this.state = {};

        this.meetingRoomReport.setDocType(DOC_TYPE.SLIDE);
        this.sceneSource = MEETING_SCENE_SOURCE.InEditor;
        this.docId = window.location.pathname.split('/').pop() || '';
        this.docType = DOC_TYPE.SLIDE;
        this.role = ROLE.MASTER;
    }

    public render(): JSX.Element {
        return (
            <MeetingRoom
                initData={{
                    sceneSource: this.sceneSource,
                    roomId: this.props.roomId,
                    docId: this.docId,
                    docType: this.docType,
                    role: this.role,
                }}
                currentPage={this.props.currentPage}
                handleEndPlay={this.props.handleEndPlay}
                liveManager={this.props.liveManager}
            >
                <div className={styles['manager-wrapper']}>
                    <div className={'wrapperStyle'} id="playerContainer" style={{ width: '100%' }}>
                        <LazyBoundary>
                            <SlidePlayer inEditor sceneSource={this.sceneSource} isPresenterView />
                        </LazyBoundary>
                    </div>
                </div>
            </MeetingRoom>
        );
    }
}
